import React from 'react'
import "./Welcome.css"

function WelCome() {
    return (
        <div className="welcome-div">
            <h1 className="welcome-msg">Welcome to<br/> FORUM!</h1>
        </div>
    )
}

export {
     WelCome
}